import { render, staticRenderFns } from "./gnb.vue?vue&type=template&id=2a8c4456&scoped=true&"
import script from "./gnb.vue?vue&type=script&lang=js&"
export * from "./gnb.vue?vue&type=script&lang=js&"
import style0 from "./gnb.vue?vue&type=style&index=0&id=2a8c4456&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c4456",
  null
  
)

export default component.exports